import { Component, Input, HostBinding } from '@angular/core';


@Component({
  moduleId: module.id,
  selector: 'settings-icon',
  templateUrl: 'settings-icon.component.html',
  styleUrls: ['settings-icon.component.scss'],
})
export class SettingsIconComponent {

  @HostBinding('class.settings-icon-wrap')
  @Input() wrapClass: boolean = true;

  @HostBinding('class.active')
  @Input() active: boolean = false;

  @Input() color: string = 'transparent'; // ['transparent', 'blue']

}
